import {favoritesQuery} from '../../../GraphQL/Query/favoritesQuery';
import {FavoritesQuery} from '../../../GraphQL/Query/types/FavoritesQuery';
import {QueueCommand} from '../../../Model/Queue/QueueCommand';
import {QueueStatus} from '../../../Model/Queue/QueueStatus';
import {favoritesLoaded} from '../../../Store/Favorite/action';
import {GraphQlClient} from '../../GraphQl/GraphQlClient';
import {StoreGateway} from '../../Store/StoreGateway';

export class DownloadFavoritesCommand implements QueueCommand {
  public constructor(private graphQlClient: GraphQlClient, private storeGateway: StoreGateway) {
  }

  public async execute(): Promise<QueueStatus> {
    try {
      const result = await this.graphQlClient.getClient().query<FavoritesQuery>({query: favoritesQuery, fetchPolicy: 'network-only'});
      if (!result) {
        return QueueStatus.Failed;
      }
      this.storeGateway.dispatch(favoritesLoaded(result.data.favorites.map(({productId}) => productId)));
      return QueueStatus.Done;
    } catch (e) {
      console.error(e);
    }
    return QueueStatus.Retry;
  }
}
